import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Col, Row, Modal } from "react-bootstrap";
import logo from "../Images/logo.svg";
import { FcGoogle } from "react-icons/fc";
import "./Navbar.css";

const Ai = () => {
  return (
    <>
      <Row
        className="d-flex justify-content-center mx-md-0 mt-md-5 mt-2 mb-md-5 mb-2 mx-2 m-md-0 m-2"
        style={{ height: "" }}
      >
        <Col md={10}>
          <Row className="mt-md-5 mt-2 mb-md-5 mb-2">
            <Col
              md={6}
              className="d-flex flex-column justify-content-center align-items-start"
            >
              <div>
              
                <h2 style={{ fontSize: "rem", color: "#00013C" }}>
                  <b>
                    Smart Tracking, Better Results
                    <br /> Only with
                    <span style={{ color: "#3C74F6" }}> Bix Tracker</span>{" "}
                  </b>
                </h2>
                <p
                  className="mt-3"
                  style={{
                    color: "#00013C",
                    fontSize: "1rem",
                    fontWeight: "500",
                  }}
                >
                 Bix Tracker is an all in one tracking and growth management tool designed to help businesses stay organized, make data driven decisions and achieve better results.

                </p>
                <div className="mt-4 d-flex gap-3">
                  <Button
                    onClick={() =>
                      window.open("https://dashboard.seobix.com/", "_blank")
                    }
                    style={{
                      backgroundColor: "#fff",
                      color: "#0D0D26",
                      border: "2px solid #3C74F6",
                      fontWeight: 600,
                      padding: "10px 20px",
                      fontSize: "1rem",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <FcGoogle size={20} />
                    <span>Start free with Google</span>
                  </Button>

                  <Button
                    onClick={() =>
                      window.open("https://dashboard.seobix.com/")
                    }
                    style={{
                      backgroundColor: "#fff",
                      color: "#0D0D26",
                      border: "2px solid #3C74F6",
                      fontWeight: 600,
                      padding: "10px 20px",
                      fontSize: "1rem",
                    }}
                  >
                    Book a Demo
                  </Button>
                </div>
              </div>
            </Col>
            <Col
              md={6}
              className="d-flex justify-content-center align-items-center"
              style={{ height: "100%" }}
            >
              <img
                src={require("../Images/bix-tracker.webp")}
                alt="Tool"
                style={{ height: "40vh" }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default Ai;
